/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Button, CircularProgress } from 'components/Antifraude'
import { getOcrTypes } from 'redux/reducers/ocr'
import CnhOpen from 'assets/cnh_aberto.svg'
import RgFront from 'assets/rg_front.svg'
import RgBack from 'assets/rg_back.svg'
import RneFront from 'assets/rne_front.svg'
import RneBack from 'assets/rne_back.svg'
import validateStageOnboarding from 'utils/validateStage'
import { roles } from 'utils/constants/roles'
import Colors from 'utils/Colors'

import { UploadContainer } from './styles'

const options = {
  cnh: { title: 'CNH Aberta', image: CnhOpen },
  rg_front: { title: 'RG/CIN Frente', image: RgFront },
  rg_back: { title: 'RG/CIN Verso', image: RgBack },
  rne_front: { title: 'RNE/RNM Frente', image: RneFront },
  rne_back: { title: 'RNE/RNM Verso', image: RneBack },
}

const supportedExts = ['jpeg', 'jpg', 'png']

export default (props) => {
  const { history, location } = props
  const { token } = useSelector((state) => state.token)
  const { types } = useSelector((state) => state.ocr)
  const [error, setError] = useState('')
  const [currentDoc, setCurrentDoc] = useState(null)
  const [loading, setLoading] = useState(false)
  const imageRef = useRef()
  const dispatch = useDispatch()

  const { state } = location

  const handleLoading = (newState) => {
    setLoading(newState)
  }

  function goToUpload(type) {
    history.replace({
      pathname: '/ocr-upload',
      state: { type: type },
    })
  }
  
  function currentTypeIsEnable(type) {
    if (!types.includes(type)) {
      if (type === 'rg_front') {
        goToUpload('rg_back')
      }
      if (type === 'rne_front') {
        goToUpload('rne_back')
      } else {
        history.replace({
          pathname: '/ocr-options',
        })
      }
    }
  }
  
  function previewImage(file) {
    history.replace({
      pathname: '/ocr-preview',
      state: {
        title: currentDoc.title,
        file: file,
        type: state.type,
        side: currentDoc.side,
      },
    })
  }

  // eslint-disable-next-line consistent-return
  function handleImage(imageReference) {
  
    const { files } = imageReference.current
    for (let i = 0; i < files.length; i++) {
      const file = files[i]

      const ext = file.name.substring(file.name.lastIndexOf('.') + 1)

      if (!supportedExts.includes(ext.toLowerCase())) {
        setError(
          'Formato de arquivo não permitido! ' +
            'Envie somente imagens no formato JPG ou PNG.',
        )
        return false
      }
    }

    previewImage(files[0])
  }

  function handleChooseDocument() {
    history.replace({
      pathname: '/ocr-options',
    })
  }

  useEffect(() => {
    validateStageOnboarding(token, history, roles.DOCUMENT_OCR, handleLoading)
  }, [])

  useEffect(() => {
    if (types.length > 0) {
      currentTypeIsEnable(state.type)
      const selected = options[state.type]

      const doc = {
        title: selected.title,
        image: selected.image,
        side: selected.side,
      }
      setCurrentDoc(doc)
    } else {
      dispatch(getOcrTypes({ token }))
    }
  }, [state])
  
  useEffect(() => {
    if (state && state.error) {
      setError(state.error)
    }
  }, [state])
  
  return loading ? (
    <div className="loading">
      <div
        className="loading__container"
        style={{ display: 'flex', justifyContent: 'center' }}
      >
        <CircularProgress style={{ textAlign: 'center' }} />
      </div>
    </div>
  ) : (
    <UploadContainer
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.4 }}
    >
      {currentDoc && (
        <div className="document-container">
          <p className="title">{currentDoc.title}</p>
          <p className="subtitle">
            Clique abaixo para tirar uma foto ou
            <br />
            selecionar uma foto da sua galeria
          </p>

          <div className="doc_model">
            <img src={currentDoc.image} alt="" />
          </div>

          {['RG/CIN Frente', 'RNE/RNM Frente'].includes(currentDoc.title) && (
            <p className="tip">
              <b style={{ color: Colors.primaryColor }}>ATENÇÃO:</b>
              <p style={{ color: '#000' }}>
                {' '}
                A <b>frente</b> do documento é a face
                <br /> que contém a sua foto 3x4.
              </p>
            </p>
          )}

          {error && <p className="error">{error}</p>}

          <div className="file_container">
            <label htmlFor="browse" className="file_container__label">
              Selecione a imagem
            </label>
            <input
              type="file"
              id="browse"
              name="browse"
              className="file_container__input"
              onChange={() => handleImage(imageRef)}
              ref={imageRef}
              accept="image/x-png,image/gif,image/jpeg"
            />
          </div>
        </div>
      )}
      <div className="change-doc">
        <Button onClick={handleChooseDocument}>
          Mudar Documento
        </Button>
      </div>
    </UploadContainer>
  )
}
